import css from "./Note.module.css";

const Note = ({ children, header, style, type }) => {
  const icons = {
    error: {
      src: "https://storage.googleapis.com/squidslippers-media/icons/no.png",
      alt: "no",
    },
    info: {
      src: "https://storage.googleapis.com/squidslippers-media/icons/info.png",
      alt: "info",
    },
    note: {
      src: "https://storage.googleapis.com/squidslippers-media/icons/speech_bubble.png",
      alt: "speech bubble",
    },
    success: {
      src: "https://storage.googleapis.com/squidslippers-media/icons/check.png",
      alt: "check",
    },
    warning: {
      src: "https://storage.googleapis.com/squidslippers-media/icons/warning.png",
      alt: "warning",
    },
  };

  return (
    <div className={`${css.main} ${css[type]}`} style={style}>
      {header && <strong className={css.header}>{header}</strong>}
      <img className={css.icon} src={icons[type]?.src} alt={icons[type]?.alt} />
      <div className={css.children}>{children}</div>
    </div>
  );
};

export default Note;
